import React from 'react';
export const TreatmentComparison = () => {
  return <section className="w-full bg-gray-50 py-10 px-4" data-id="element-419">
      <div className="max-w-4xl mx-auto" data-id="element-420">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-421">
          Pourquoi les Traitements Actuels Échouent
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-sm mb-8" data-id="element-422">
          <p className="text-gray-700 mb-6" data-id="element-423">
            Pendant des années, la médecine a essayé de traiter la neuropathie
            avec des pilules : Lyrica, gabapentine, Cymbalta.
          </p>
          <p className="text-gray-700 mb-6 font-bold" data-id="element-424">
            Résultat ? 50% des patients ne ressentent AUCUNE amélioration. Les
            autres développent des effets secondaires terribles :
          </p>
          <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-425">
            <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-426">
              <div className="bg-blue-600 text-white p-3 font-bold" data-id="element-427">
                Lyrica (prégabaline)
              </div>
              <div className="p-4" data-id="element-428">
                <p className="mb-2" data-id="element-429">
                  <span className="font-bold" data-id="element-430">Efficacité :</span> environ 50%
                  des patients
                </p>
                <p data-id="element-431">
                  <span className="font-bold" data-id="element-432">Effets secondaires :</span> Prise
                  de poids (+15kg), somnolence, brouillard mental
                </p>
              </div>
            </div>
            <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-433">
              <div className="bg-blue-600 text-white p-3 font-bold" data-id="element-434">
                Gabapentine
              </div>
              <div className="p-4" data-id="element-435">
                <p className="mb-2" data-id="element-436">
                  <span className="font-bold" data-id="element-437">Efficacité :</span> environ 45%
                  des patients
                </p>
                <p data-id="element-438">
                  <span className="font-bold" data-id="element-439">Effets secondaires :</span>{' '}
                  Vertiges, chutes, dépendance
                </p>
              </div>
            </div>
            <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-440">
              <div className="bg-blue-600 text-white p-3 font-bold" data-id="element-441">
                Cymbalta
              </div>
              <div className="p-4" data-id="element-442">
                <p className="mb-2" data-id="element-443">
                  <span className="font-bold" data-id="element-444">Efficacité :</span> environ 40%
                  des patients
                </p>
                <p data-id="element-445">
                  <span className="font-bold" data-id="element-446">Effets secondaires :</span>{' '}
                  Nausées, sueurs, sevrage difficile
                </p>
              </div>
            </div>
          </div>
          <div className="bg-yellow-50 p-4 rounded-lg mb-6" data-id="element-447">
            <h3 className="font-bold text-lg mb-2" data-id="element-448">
              Témoignage de Francine, 64 ans, Sherbrooke :
            </h3>
            <p className="text-gray-700 italic" data-id="element-449">
              "J'ai pris du Lyrica pendant 2 ans. J'ai pris 18 kilos, je dormais
              14 heures par jour, et mes douleurs étaient toujours là. Mon
              médecin me disait : 'Il faut vivre avec.' Je refusais de croire
              que c'était la seule option."
            </p>
          </div>
          <p className="text-gray-700 font-bold" data-id="element-450">
            Le problème ? Ces médicaments ne font que masquer la douleur. Ils ne
            traitent pas la cause : la mauvaise circulation et l'inflammation
            nerveuse.
          </p>
        </div>
      </div>
    </section>;
};